<template>
  <div class="page flex-col">
    <div class="header flex-row">
      <BackButton
        :customClick="handleBackClick"
        class="back"
      />
    </div>

    <div class="menu flex-row">
      <TeacherMenu />
    </div>

    <div class="container flex-row">
      <div class="marks flex-col">
        <div
          class="marks_wrapper flex-row"
          v-for="(mark, index) in marks"
          :key="index"
          :class="{ mark_active: idx == index }"
          @click="scrollToMark(index)"
        >
          <span
            class="mark_text"
            :class="{ mark_text_active: idx == index }"
            >❖&nbsp;{{ mark }}</span
          >
        </div>
      </div>

      <div class="contents flex-col">
        <span class="lesson_name">{{ lessonName }}</span>
        <div class="contents_wrapper">
          <div
            class="content flex-col"
            v-for="(mark, index) in marks"
            :key="index"
          >
            <span class="content_title">{{ mark }}</span>
            <!-- wangEditor  -->
            <div
              class="content_text"
              v-html="tichText[index]"
            ></div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="goToTop"
      @click="goToTop"
    ></div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue"
import { useRoute, useRouter } from "vue-router"
import { useStore } from "vuex"

import BackButton from "@/components/teacher/BackButton.vue"
import TeacherMenu from "@/components/teacher/TeacherMenu.vue"
import alovaInstance from "@/utils/alova"

const route = useRoute()
const router = useRouter()
const store = useStore()
const idx = ref(-1)
const marks = ref([
  "主要概念",
  "学习目标",
  "所需设备/资源",
  "课前准备",
  "课堂大纲",
  "教学活动详情",
  "评估",
])
// const tichText = ref([
//   '<p><br></p><ul><li style="text-align: start;">print 函式</li><li style="text-align: start;">缩排</li><li style="text-align: start;">变量</li><li style="text-align: start;">四则运算</li></ul><p><br></p>',
//   '<ul><li style="text-align: start;">认识 Python 的基本编程语法及格式</li><li style="text-align: start;">学习运用 Python 中的变量</li><li style="text-align: start;">学习运用 Python 中的基本算术运算子（加法、减法、乘法、除法）</li></ul>',
//   '<p><br></p><ul><li style="text-align: start;">print 函式</li><li style="text-align: start;">缩排</li><li style="text-align: start;">变量</li><li style="text-align: start;">四则运算</li></ul><p><br></p>',
//   '<ul><li style="text-align: start;">认识 Python 的基本编程语法及格式</li><li style="text-align: start;">学习运用 Python 中的变量</li><li style="text-align: start;">学习运用 Python 中的基本算术运算子（加法、减法、乘法、除法）</li></ul>',
//   '<p><br></p><ul><li style="text-align: start;">print 函式</li><li style="text-align: start;">缩排</li><li style="text-align: start;">变量</li><li style="text-align: start;">四则运算</li></ul><p><br></p>',
//   '<ul><li style="text-align: start;">认识 Python 的基本编程语法及格式</li><li style="text-align: start;">学习运用 Python 中的变量</li><li style="text-align: start;">学习运用 Python 中的基本算术运算子（加法、减法、乘法、除法）</li></ul>',
//   '<p><br></p><ul><li style="text-align: start;">print 函式</li><li style="text-align: start;">缩排</li><li style="text-align: start;">变量</li><li style="text-align: start;">四则运算</li></ul><p><br></p>',
// ])
const tichText = ref([])
const lessonName = ref("")

const scrollToMark = (index) => {
  idx.value = index
  // 找到对应内容区域元素
  const contentElement = document.querySelector(
    `.contents_wrapper .content:nth-child(${index + 1})`
  )
  if (contentElement) {
    // 平滑滚动到内容区域顶部
    contentElement.scrollIntoView({
      behavior: "smooth",
      block: "start",
    })
  }
}

const goToTop = () => {
  // scrollToMark(0)
  idx.value = 0
  // 找到对应内容区域元素
  const contentElement = document.querySelector(`.page:nth-child(${1})`)
  if (contentElement) {
    // 平滑滚动到内容区域顶部
    contentElement.scrollIntoView({
      top: "0",
      block: "start",
    })
  }
}

onMounted(async () => {
  lessonName.value = store.getters.getLessonName
  try {
    let lessonId = route.query.lessonId
    const response = await alovaInstance.Post("/Record/GetLessonOutline", {
      lessonId: lessonId,
    })
    // console.log(response)
    if (response.code === 1000) {
      tichText.value = []
      if (response.data == null) return
      // 按serial_no升序排序
      response.data.sort((a, b) => a.serial_no - b.serial_no)
      for (let i = 0; i < response.data.length; i++) {
        tichText.value.push(response.data[i].content)
      }
    } else {
      alert("获取数据失败：" + response.message)
    }
  } catch (error) {
    console.error("获取数据失败:", error)
    alert("获取数据失败，请稍后重试")
  }
})

const handleBackClick = () => {
  router.push({
    name: "TeacherCourse",
    query: {
      courseName: store.state.courseName,
      courseId: store.state.courseId,
    },
  })
}
</script>

<style src="@/assets/common.css" />
<style scoped>
.page {
  background-color: rgba(234, 238, 242, 1);
  position: relative;
  width: 100%;
  height: auto;
  overflow: hidden;
}

.header {
  width: 80.6771vw;
  height: 3.4375vw;
  margin: 0.8854vw 0 0 1.5vw;
}

.back {
  margin-right: 1.5vw;
}

.menu {
  width: auto;
  height: auto;
  margin: 0 0 0 1.5vw;
}

.container {
  width: auto;
  height: auto;
}

.marks {
  margin: 3.96vw 1.5vw;
}

.marks_wrapper {
  background-color: rgba(220, 233, 246, 1);
  border-radius: 8px;
  height: 2.4vw;
  border: 1px solid rgba(104, 162, 250, 1);
  width: 11.05vw;
  margin-bottom: 0.78vw;
  cursor: pointer;
}

.mark_active {
  background-color: rgba(55, 91, 165, 1);
}

.mark_text {
  width: 10vw;
  height: 1.36vw;
  overflow-wrap: break-word;
  color: rgba(34, 76, 123, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
  margin: 0.6vw 0 0 0.83vw;
}

.mark_text_active {
  color: #fff;
}

.contents {
  width: auto;
  height: auto;
}

.lesson_name {
  width: 30vw;
  height: 1.67vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 1.25vw;
  font-family: Microsoft YaHei-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 1.25vw;
  margin: 1.3vw 0 1vw 0;
}

.contents_wrapper {
  width: auto;
  height: auto;
}

.content {
  width: 68.45vw;
  height: auto;
  background: #ffffff;
  border-radius: 0.83vw 0.83vw 0.83vw 0.83vw;
  padding: 1.25vw 2vw;
  margin-bottom: 1.25vw;
}

.content_title {
  width: 5vw;
  height: 1.67vw;
  overflow-wrap: break-word;
  color: rgba(55, 91, 165, 1);
  font-size: 1.25vw;
  font-family: Microsoft YaHei-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 1.25vw;
}

.content_text {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 0.9vw;
  color: #404850;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-top: 0.5vw;
}

.goToTop {
  position: fixed;
  bottom: 20px;
  right: 40px;
  width: 40px;
  height: 40px;
  display: block;
  background: url(../../assets/teacher/plan/arrow.top.white.svg) center center /
    15px 8px no-repeat rgba(90, 172, 255, 0.8);
  border-radius: 50%;
  z-index: 999;
  cursor: pointer;
}
</style>
